import {useEffect, useState} from 'react';
import { useLang } from '../context/LanguageContext';
import sub1Header from '../images/header_promo.png';
import sub1Footer from '../images/bottom_promo1.png';
import sub2Header from '../images/header_promo.png';
import sub2Footer from '../images/bottom_promo3.png';
import sub3Header from '../images/header_promo.png';
import sub3Footer from '../images/bottom_promo6.png';

export default function useSubscriptions() {
    const { t, language } = useLang();

    const defaultSubscriptions = [
        {
            id: "3456-aaa3-bbb3",
            title: t('subs.vip.title'),
            subtitle: t('subs.vip.subtitle'),
            facilities: t('subs.vip.facilities'),
            price: t('subs.vip.price'),
            priceId: process.env.REACT_APP_STRIPE_VIP_PRICE_ID,
            headerImg: sub1Header,
            footerImg: sub1Footer,
            languages: ['ro', 'en'],
            usage: [1],
        },
        {
            id: "a2d5-a2d5-a2d5",
            title: t('subs.vipOnly.title'),
            subtitle: t('subs.vipOnly.subtitle'),
            facilities: t('subs.vipOnly.facilities'),
            price: t('subs.vipOnly.price'),
            priceId: process.env.REACT_APP_STRIPE_VIP_ONLY_PRICE_ID,
            headerImg: sub1Header,
            footerImg: sub1Footer,
            languages: ['ro', 'en'],
            usage: [2],
        },
        {
            id: "556d-415b-aa84",
            title: t('subs.sub1.title'),
            facilities: t('subs.sub1.facilities'),
            price: t('subs.sub1.price'),
            priceId: process.env.REACT_APP_STRIPE_1_PRICE_ID,
            headerImg: sub1Header,
            footerImg: sub1Footer,
            languages:['ro', 'en', 'es'],
            usage: [1],
        },
        {
            id: "a18b-4265-a4a7",
            title: t('subs.sub2.title'),
            facilities: t('subs.sub2.facilities'),
            price: t('subs.sub2.price'),
            priceId: process.env.REACT_APP_STRIPE_3_PRICE_ID,
            headerImg: sub2Header,
            footerImg: sub2Footer,
            languages:['ro', 'en', 'es'],
            usage: [1],
        },
        {
            id: "445f-4627-b7ae",
            title: t('subs.sub3.title'),
            facilities: t('subs.sub3.facilities'),
            price: t('subs.sub3.price'),
            priceId: process.env.REACT_APP_STRIPE_6_PRICE_ID,
            headerImg: sub3Header,
            footerImg: sub3Footer,
            languages:['ro', 'en', 'es'],
            usage: [1],
        },
    ]


    const [subscriptions, setSubscriptions] = useState(defaultSubscriptions);

    useEffect(() => {
        setSubscriptions(defaultSubscriptions.filter(sub => sub.languages.includes(language)))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language]);


    return subscriptions;
}